let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("bI3DO"), load("3UR1K"), load("4Oj5y")]).then(() => parcelRequire('2JKSZ'));